import stockTransfer from '@/api/stock-transfer'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  to_warehouses: [],
  branches: [],
  products: [],
  uom: [],
  transfer_type: ''
}

export const getters = {
  uomGetter: state => ObjectRow => {
    let result = state.products.filter(
      p => p.product_id == ObjectRow.product_id
    )
    if (result.length > 0) {
      return state.uom.filter(u => u.uom_cat_id == result[0].uom_cat_id)
    }
    return []
  },
  productPrice: state => (productId, uomId) => {
    try {
      return _.flatten(
        state.products.find(p => p.product_id == productId).sale_code
      ).find(sc => sc.uom_id == uomId).product_price
    } catch (e) {
      return ''
    }
  },
  totalAmount: (state, getters) => detail => {
    try {
      let amount = detail.cost * detail.qty
      return _.ceil(amount, 2)
    } catch (e) {
      return 0
    }
  }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_TO_WAREHOUSES(state, data) {
    state.to_warehouses = data
  },
  SET_BRANCHES(state, data) {
    state.branches = data
  },
  SET_PRODUCT(state, data) {
    state.products = data
  },
  SET_UOM(state, data) {
    state.uom = data
  },
  SET_TRANSFER_TYPE(state, data) {
    state.transfer_type = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        transfer_type: context.state.transfer_type
      },
      attrubutes
    )
    return stockTransfer.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return stockTransfer.store(data)
  },

  update(context, data) {
    return stockTransfer.update(data)
  },
  destroy(context, id) {
    return stockTransfer.destroy(id)
  },

  confirm(context, data) {
    return stockTransfer.updateStatus(data)
  },

  reject(context, data) {
    return stockTransfer.updateStatus(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await stockTransfer.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.to_warehouses.length > 0) {
      let response = await stockTransfer.toWarehouse()
      context.commit('SET_TO_WAREHOUSES', response)
    }
    if (!context.state.branches.length > 0) {
      let response = await stockTransfer.branch()
      context.commit('SET_BRANCHES', response)
    }
    if (!context.state.products.length > 0) {
      let response = await stockTransfer.product()
      context.commit('SET_PRODUCT', response)
    }
    if (!context.state.uom.length > 0) {
      let response = await stockTransfer.uom()
      context.commit('SET_UOM', response)
    }
    return Promise.resolve()
  },

  previewPdf(context, id) {
    return stockTransfer.printPDF(id)
  }
}
